import React from 'react';
import { motion } from 'framer-motion';

export default function EventsHero() {
  return (
    <section className="relative flex-grow min-h-[80vh] md:min-h-[90vh] w-full">
      <div 
        className="absolute inset-0 w-full h-full overflow-hidden"
        style={{
          backgroundImage: 'url("/images/Wind-mill-Photo.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      <div className="relative h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl bg-black/50 p-8 rounded-xl backdrop-blur-sm"
          >
            <h1 className="text-5xl font-bold text-white mb-6">
              Events & Conferences
            </h1>
            <p className="text-xl text-green-100 mb-8">
              Stay updated with our upcoming events and conferences focused on advancing climate finance and sustainability in Africa.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}